<script setup lang="ts">
import { primaryLogoUrl } from '../lib/brand'
</script>

<template>
  <section class="closing-section" aria-labelledby="closing-title">
    <div class="closing-section__nodes" aria-hidden="true">
      <i v-for="index in 24" :key="index" :style="{ '--index': index }" />
    </div>
    <div class="closing-section__mark" data-reveal>
      <img :src="primaryLogoUrl" alt="SE 2026" width="104" height="104" />
      <span aria-hidden="true" />
    </div>
    <p class="section-kicker" data-reveal>READY FOR YOUR FIRST COMMIT</p>
    <h2 id="closing-title" data-reveal>你的大学四年，<br />还没有被写入。</h2>
    <a class="primary-action" href="#top" data-reveal>
      <span>重新进入宇宙</span>
      <i aria-hidden="true">↑</i>
    </a>

    <footer class="site-footer" role="contentinfo">
      <div class="site-footer__brand">
        <strong>SE UNIVERSE</strong>
        <span>2026 软件工程新生数字计划</span>
      </div>
      <p>由软件工程学长发起的非官方新生数字计划，具体培养方案与通知以学校和学院正式信息为准。</p>
      <span>MADE WITH CURIOSITY · 2026</span>
    </footer>
  </section>
</template>
